var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('fields',{ref:"fields",attrs:{"schoolId":_vm.schoolId,"gradeId":_vm.gradeId,"userId":_vm.userId},on:{"search":function($event){return _vm.$emit('search', $event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }